<div class="login-new" id="register-container">
  <div id="register-header">
    <h5 class="onboarding-title" id="register-title">{{'signup_title' | translate: { trialDays: trialDays } }}</h5>
    <p class="onboarding-subtitle" id="register-subtitle">{{'signup_sub_title' | translate}}</p>
  </div>
  <div class="one-col-grid input-no-margin" id="register-form">
    <ds-textbox
      [textboxInput]="firstnameInputConfig"
      (valueChange)="onFirstNameChange($event)"
      (keypress)="omitSpecialChar($event)">
    </ds-textbox>
    <ds-textbox
      [textboxInput]="lastnameInputConfig"
      (valueChange)="onLastNameChange($event)"
      (keypress)="omitSpecialChar($event)">
    </ds-textbox>
    <ds-textbox
      #emailInput
      [textboxInput]="emailInputConfig"
      (valueChange)="onEmailChange($event)">
    </ds-textbox>
    <ds-button
      [buttonInput]="signUpConfig"
      (btnClick)="onRegistrationSubmit()"
    ></ds-button>
  </div>
  <hr class="hr-border-muted" id="register-divider">
  <div class="login-links" id="register-login-links">
       <p id="register-login-text">{{ "already_have_account" | translate }}
       <a (click)="gotoLogin()" class="link" id="register-login-link">{{ "login" | translate }}</a></p>
  </div>
</div>

<app-existing-domain
    [id]="'existing-domain-modal'"
    #domainAlreadyRegisteredModal
    [firstname]="firstname"
    [lastname]="lastname"
    [email]="email"
    [domainName]="domainName"
    [userrequest]="userrequest"
    (loginRedirect)="gotoLogin()">
</app-existing-domain>